import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
export const DiscardChangesHandler = () => {
    const { formState, getValues, control } = useFormContext();
    useEffect(() => {
        const listener = (event) => {
            event.preventDefault();
        };
        if (!formState.isSubmitting && formState.isDirty) {
            window.addEventListener('beforeunload', listener);
        }
        return () => {
            window.removeEventListener('beforeunload', listener);
        };
    }, [formState.isSubmitting, formState.isDirty, getValues, control]);
    return null;
};
